module.exports = __webpack_public_path__ + "static/img/009.ea55b62a.jpg";